export class AttachmentBlobUrl {
  public AttachmentId: string
  public BlobUrl: string

  constructor (attachmentId: string, blobUrl: string) {
    this.AttachmentId = attachmentId
    this.BlobUrl = blobUrl
  }
}
